<template>
    <div>
        <div class="modal-mask"></div>
        <div class="modal-wrapper">
            <div class="renew">
                <div v-if="!status">
                    <div class="renew-t">
                        <p>正在进行会员续费</p>
                        <div class="iconfont icon-guanbi" @click="closeBack"></div>
                    </div>
                    <div class="renew-con" id="loadingObj" v-loading="loading" element-loading-text="加载中...">
                        <div class="renew-type">
                            <div class="tit-txt">当前类型：</div>
                            <div class="tit-name">{{vipName}}</div>
                        </div>
                        <div class="renew-time">
                            <div class="renew-time-l ">
                                <div class="tit-txt">续费时长：</div>
                                <div class="tit-name">{{vipDuration}}个月</div>
                            </div>
                            <div class="renew-time-r">有效期延长至{{vipEnd.split(' ')[0]}}</div>
                        </div>
                        <div class="renew-moeny">
                            <div class="tit-txt">应付金额：</div>
                            <div class="tit-name" style="color:#ff6511;font-size:22px;">{{vipPrice}}元</div>
                        </div>
                        <div class="renew-pays" style="position: relative;">
                            <div class="renew-pays-tit">充值方式</div>
                            <div class="renew-pays-ts" v-show="alipay">开发中，暂不支持</div>
                            <div class="renew-pays-list">
                                <div @click="paySel('alipay')" class="renew-pays-li"
                                     :class="{'active' :  payway == 'alipay'}">
                                     <img v-if="payway == 'alipay'"  src="../../assets/images/sanjiao_small.png"  class="paygou">
                                    <img src="../../assets/images/alapy.png">
                                </div>
                                <div @click="paySel('wxpay')" class="renew-pays-li"
                                     :class="{'active' : payway == 'wxpay'}"
                                     style="margin-right:30px;">
                                     <img v-if="payway == 'wxpay'"  src="../../assets/images/sanjiao_small.png"  class="paygou">
                                    <img src="../../assets/images/wxpay.png">
                                </div>
                            </div>
                        </div>
                        <div class="renew-b">
                            <div class="renew-ewm">
                                <img :src="base64Img" alt="二维码">
                            </div>
                            <div class="renew-b-txt">扫描左侧二维码完成续费</div>
                        </div>
                    </div>
                </div>
                <div v-if="status" class="renew-con" style="padding: 40px 0 30px 0;">
                    <div class="renew-sucimg">
                        <img src="//oss.51ztx.com//money_suc.gif">
                    </div>
                    <div class="renew-xfcg">续费成功！</div>
                    <p class="renew-xyrq">您的会员续约至2019年03月23日</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
//    import { Loading } from 'element-ui';
    const qrcode = require('qrcode-js');
    export default {
        data(){
            return {
                alipay:'',
                payway: 'alipay',
                vipinfo:{},
                status:0,
                base64Img:'',
                interval:null,
                vipName:'',
                vipDuration:'',
                vipEnd:'',
                vipPrice:'',
                loading:true
            }
        },
        watch:{
            alipay(newval,oldval){
                if(newval){
                    setTimeout(()=>{
                        this.alipay = '';
                    },1500)
                }
            }
        },
        created(){
            //默认支付宝支付
            let url = '/wapi/company/getDelayVipQR4AliCode';
            this.getDelayVipCode(url);
        },
        methods: {
            //续费二维码
            getDelayVipCode(url){
                this.axios.get(url).then(res => {
                    if(res.success){
                        setTimeout(()=>{
                            this.loading = false;
                        },300)
                        this.vipinfo = res.data;
                        this.vipName = res.data.vipName;
                        this.vipDuration = res.data.vipDuration;
                        this.vipEnd = res.data.vipEnd;
                        this.vipPrice = res.data.vipPrice;
                        this.base64Img = qrcode.toDataURL(res.data.qrCode, 4);
                        this.intervalResult();
                    }
                });
            },
            closeBack(){
                clearInterval(this.interval);
                this.$router.back();
            },
            paySel(val){
                this.payway = val;

                clearInterval(this.interval);//清除上次订单状态轮询

                let url = '/wapi/company/getDelayVipQR4WXCode';//默认微信

                if(val == 'alipay'){
                    url = '/wapi/company/getDelayVipQR4AliCode';
                }
                this.getDelayVipCode(url);
            },
            intervalResult(){
                this.interval = setInterval(function () {
                    if(this.status == 1){
                        clearInterval(this.interval);
                        setTimeout(()=> {
                            this.$router.back();
                        },2000)
                    }else{
                        this.queryPayOrder(this.vipinfo.sn);
                    }
                }.bind(this),1500);
            },
            queryPayOrder(sn){
                this.axios.get('/wapi/company/queryPayOrder?sn='+ sn).then(res => {
                    this.status = res.data.status;
                })
            },

        }
    }
</script>
<style scoped>
    .modal-mask {
        display: table;
        position: fixed;
        z-index: 98;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        transition: opacity .25s linear;
    }

    .modal-wrapper {
        display: table-cell;
        position: fixed;
        z-index: 99;
        top: 50%;
        left: 50%;
        vertical-align: middle;
        transform: translate(-50%, -50%);
        -webkit-transform: translate(-50%, -50%);
        transition: all .2s linear;
    }

    .renew {
        width: 390px;
        height: auto;
        border-radius: 5px;
        background-color: #fff;
    }

    .renew .renew-t {
        font-size: 16px;
        color: #666;
        height: 50px;
        line-height: 50px;
        position: relative;
        text-align: center;
        overflow: hidden;
        width: 100%;
        border-bottom: 1px solid #e5e5e5;
    }

    .renew .icon-guanbi {
        position: absolute;
        display: block;
        cursor: pointer;
        color: #999;
        right: 20px;
        top: 0;
    }

    .renew-con {
        width: 350px;
        margin: 0 auto;
    }

    .renew-con .renew-type {
        height: 68px;
        line-height: 68px;
        border-bottom: 1px dashed #e5e5e5;
    }

    .renew-con .tit-txt {
        color: #999;
        font-size: 14px;
        float: left;
    }

    .renew-con .tit-name {
        font-size: 14px;
        color: #333;
        float: left;
    }

    .renew-time {
        height: 68px;
        line-height: 68px;
        border-bottom: 1px dashed #e5e5e5;
        overflow: hidden;
    }

    .renew-time .renew-time-l {
        float: left;
    }

    .renew-time .renew-time-r {
        float: right;
        color: #495fcd;
        font-size: 14px;
    }

    .renew-moeny {
        height: 69px;
        line-height: 68px;
        border-bottom: 1px dashed #e5e5e5;
    }

    .renew .renew-pays-tit {
        color: #999;
        font-size: 14px;
        margin: 20px 0 5px 0;
        text-align: left;
    }
    .renew .renew-pays-ts{
        position: absolute;right: 65px;top: 4px;font-size: 12px;color: #ff3535;
    }
    .renew .renew-pays-list {
        overflow: hidden;
    }

    .renew .renew-pays-li {
        position: relative;
        width: 158px;
        height: 54px;
        border: 1px solid #e5e5e5;
        cursor: pointer;
        float: left;
    }

    .renew .renew-pays-li.active {
        border-color: #495fcd;
        box-shadow: 0 0 2px #495fcd;
    }
    .renew .renew-pays-li .paygou{
        position: absolute;
        width: 22px;
        height: 22px;
        top: -1px;
        right: -1px;
        z-index: 2;
    }

    .renew .renew-b {
        margin-top: 20px;
        overflow: hidden;
        padding-bottom: 30px;
    }

    .renew .renew-b .renew-ewm {
        width: 160px;
        height: 160px;
        border: 1px solid #e5e5e5;
        float: left;
    }
    .renew .renew-b .renew-ewm img{
        width: 100%;
    }
    .renew .renew-b-txt {
        color: #999;
        font-size: 14px;
        float: left;
        margin: 65px 0 0 20px;
    }

    .renew .renew-con {
        /*padding-top: 40px;*/
        /*padding-bottom: 30px;*/
        text-align: center;
    }

    .renew .renew-sucimg {
        width: 270px;
        height: 270px;
        margin: 0 auto;
        overflow: hidden;
    }

    .renew .renew-sucimg img {
        width: 100%;
        height: 100%;
        overflow: hidden;
    }

    .renew-xfcg {
        font-size: 18px;
        color: #ff971c;
        margin: 20px 0 5px;
    }

    .renew-xyrq {
        font-size: 14px;
        color: #999;
    }
</style>





// WEBPACK FOOTER //
// renew.vue?24148472